import { ICurrencyServiceMock } from "./currency.types";

export const mockCurrencyService = (): ICurrencyServiceMock => ({
  getCurrenciesPage: jest.fn(),
});
